// Branded client guide; intentionally separate from the official importation conditions.
export const TITRE_GUIDE_PATH = '/titre-exemption-2026/Pawsome-Cayman-Titre-Exemptions-2026.pdf';
export const TITRE_GUIDE_URL = `${process.env.REACT_APP_BACKEND_URL}${TITRE_GUIDE_PATH}`;